module.exports = __webpack_public_path__ + "img/dg.c93314aa.svg";